// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleGroupManifest } from '@platform/core/types/modularity/IModuleGroupManifest';
import { analyticalToolsManifest } from './analytical-tools';
import { factorAnalysisManifest } from './factor-analysis';
import { foresightManifest } from './foresight';
import { publicChallengesManifest } from './public-challenges';
import { strategyManifest } from './strategy';

/** Група модулів «Аналіз» (Analysis): 5 модулів. */
export const analysisGroup: IModuleGroupManifest = {
  key: 'analysis',
  category: 'Analysis',
  name: { en: 'Analysis', uk: 'Аналіз' },
  sort: 11,
  modules: [analyticalToolsManifest, factorAnalysisManifest, foresightManifest, publicChallengesManifest, strategyManifest],
};
